import script from "./WorldPage.vue?vue&type=script&setup=true&lang=js"
export * from "./WorldPage.vue?vue&type=script&setup=true&lang=js"

import "./WorldPage.vue?vue&type=style&index=0&id=9b75f52e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9b75f52e"]])

export default __exports__